import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Download } from "lucide-react";

export default function PortalEstimates() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/portal/estimates").then(({ data }) => setRows(data)); }, []);
  if (!rows) return <div className="p-6 font-bold uppercase text-sm">Loading estimates…</div>;

  const downloadPdf = async () => {
    const res = await api.get("/portal/estimates/pdf", { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = "CropEstimateSummary.pdf";
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  const withEst = rows.filter((r) => r.tons_per_acre != null);
  return (
    <div className="space-y-3" data-testid="portal-estimates">
      {rows.length > 0 && (
        <div className="flex justify-end">
          <button data-testid="portal-est-pdf" onClick={downloadPdf} className="h-10 px-4 bg-[#1F3D34] text-white font-bold uppercase text-xs flex items-center gap-2"><Download size={14} /> Download PDF Summary</button>
        </div>
      )}
      <div className="bg-white border border-stone-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#1F3D34] text-white text-left text-[10px] uppercase">
              <th className="p-3">Block</th><th className="p-3">Variety</th><th className="p-3 text-right">Acres</th>
              <th className="p-3">Method</th><th className="p-3 text-right">Tons / Acre</th><th className="p-3 text-right">Est. Total Tons</th>
              <th className="p-3 text-right">Actual Tons</th><th className="p-3 text-right">Variance</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.block_id} data-testid={`portal-est-${r.block_id}`} className="border-t border-stone-200">
                <td className="p-3 font-bold">{r.block}<div className="text-[10px] font-normal text-stone-500">{r.ranch_number} · {r.vineyard_name}</div></td>
                <td className="p-3">{r.variety || "—"}</td>
                <td className="p-3 text-right">{r.acres ?? "—"}</td>
                <td className="p-3">
                  {r.method === "post_veraison" ? <span className="text-[10px] font-bold uppercase bg-[#7C9673] text-white px-2 py-0.5">Post-Veraison</span>
                    : r.method === "lag_projection" ? <span className="text-[10px] font-bold uppercase bg-amber-200 text-amber-900 px-2 py-0.5">Lag Projection</span>
                    : <span className="text-stone-400">—</span>}
                </td>
                <td className="p-3 text-right font-bold">{r.tons_per_acre ?? "—"}</td>
                <td className="p-3 text-right font-bold">{r.total_tons ?? "—"}</td>
                <td className="p-3 text-right">{r.actual_tons ?? "—"}</td>
                <td className={`p-3 text-right font-semibold ${r.variance_pct == null ? "" : r.variance_pct >= 0 ? "text-[#1F3D34]" : "text-red-700"}`}>
                  {r.variance_pct != null ? `${r.variance_pct > 0 ? "+" : ""}${r.variance_pct}%` : "—"}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={8} className="p-8 text-center text-stone-400 font-bold uppercase text-sm" data-testid="portal-est-empty">No crop data yet for your blocks</td></tr>
            )}
          </tbody>
        </table>
      </div>
      {withEst.length > 0 && (
        <div className="bg-[#1F3D34] text-white p-4 text-sm" data-testid="portal-est-summary">
          <span className="font-bold uppercase text-[10px] text-white/60 mr-3">Season Estimate</span>
          <b>{Math.round(withEst.reduce((s, r) => s + (r.total_tons || 0), 0) * 10) / 10} tons</b> projected across {withEst.length} estimated block{withEst.length === 1 ? "" : "s"}
        </div>
      )}
    </div>
  );
}
